import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeBikerackAlt = function SvgLargeBikerackAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 68 68",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#large-bikerack-alt_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M65.9 6.4c-1.2 0-2.1 1-2.1 2.1v26.7c-2.3-2-5.2-3.3-8.5-3.3-1 0-2 .1-3 .4l-6.6-15.4c.2-.4.2-.8.2-1.2 0-1.7-1.4-3.1-3.1-3.1-1.7 0-3.1 1.4-3.1 3.1 0 1.4.9 2.5 2.2 3l3.3 7.8-1.2.3c-2.7.9-4.9 2.8-6.1 5.3l-3.6 7.2c-.3.6-.7 1.1-1.1 1.5-.4-.2-.9-.4-1.4-.4l-8.3-19h.9c1.2 0 2.1-1 2.1-2.1s-1-2.1-2.1-2.1h-8.5c-1.2 0-2.1 1-2.1 2.1s1 2.1 2.1 2.1h2.9l9 20.7c-.1.1-.2.3-.2.4h-2.3c-1-6-6.2-10.6-12.6-10.6-7 0-12.7 5.7-12.7 12.7 0 7 5.7 12.8 12.8 12.8 6.3 0 11.6-4.6 12.6-10.6h2.3c.7 1.3 2.1 2.1 3.7 2.1 2.3 0 4.3-1.9 4.3-4.3v-.1c1.1-.9 1.9-2 2.6-3.3l3.6-7.2c.8-1.5 2.1-2.7 3.7-3.2l1.5-.5 1.5 3.6c-3.5 2.3-5.9 6.2-5.9 10.7 0 7 5.7 12.8 12.8 12.8 3.3 0 6.2-1.2 8.5-3.3v1.1c0 1.2 1 2.1 2.1 2.1 1.2 0 2.1-1 2.1-2.1V8.5c-.2-1.2-1.1-2.1-2.3-2.1zM12.8 36.1c.6 0 1.2.1 1.8.2l-3.1 6.2h-7c1-3.6 4.3-6.4 8.3-6.4zm0 17c-4 0-7.3-2.7-8.2-6.4h8.3c.8 0 1.5-.5 1.9-1.2l3.6-7.3c1.8 1.6 2.9 3.8 2.9 6.4 0 4.7-3.9 8.5-8.5 8.5zm42.5 0c-4.7 0-8.5-3.8-8.5-8.5 0-2.7 1.3-5.2 3.3-6.7l3.2 7.6c.3.8 1.1 1.3 2 1.3.3 0 .6-.1.8-.2 1.1-.5 1.6-1.7 1.1-2.8L54 36.2c.4-.1.8-.1 1.3-.1 4.7 0 8.5 3.8 8.5 8.5s-3.8 8.5-8.5 8.5z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "large-bikerack-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h68v68H0z"
  }))));
};

export default SvgLargeBikerackAlt;